
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNotificacionStore, useUIStore } from "../../../../hooks";
import moment from "moment";



export const TablaSalidas = () => {



    const  { salidas, setActiveNotaEnvio } = useNotificacionStore();
    const { openModalNoti } = useUIStore();


    const handleVerInfo = (entrada) => {
        setActiveNotaEnvio(entrada);
        openModalNoti();
    }



    return (

        <Grid  container sx={{ mt:10 }}>

            <Grid container direccion='row' alignItems='center'>

                <Box flex={ 1 } />

                <Typography variant='h1'>Salidas</Typography>

                <Box flex={ 1 } />

            </Grid>

            <TableContainer>
                <Table sx={{ minWidth: 700, }}>

                    <TableHead >
                        <TableRow>
                            <TableCell>PRODUCTO</TableCell>
                            <TableCell>CANTIDAD</TableCell>
                            <TableCell>CANTIDAD INICIAL</TableCell>
                            <TableCell>CANTIDAD FINAL</TableCell>
                            <TableCell>RECIBE</TableCell>
                            <TableCell>FECHA INICIO</TableCell>
                            <TableCell>FECHA FIN</TableCell>
                        </TableRow>

                    </TableHead>

                    { salidas &&(
                    <TableBody>
                    { salidas.map( ( salida ) => (

                        <TableRow key={ salida.id } onClick={ () => handleVerInfo(salida) }
                            style={{ backgroundColor: (salida.para) ? '#F6CECE' : '#F5DA81' }}
                        >
                            <TableCell>{ salida.producto?.nombre }</TableCell>   
                            <TableCell>{ salida.cantidad }</TableCell>
                            <TableCell>{ salida.cantidadInicialEnvia }</TableCell>   
                            <TableCell>{ salida.cantidadFinalEnvia }</TableCell>
                            <TableCell>{ (salida.para) ? salida.para?.nombre : salida.paraLote.lote }</TableCell>   
                            <TableCell>{  moment(salida.createdAt).format('l') }</TableCell>
                            <TableCell>{  moment(salida.dateRecibe).format('l') }</TableCell>
                        </TableRow>
                    ))
                    }
                    </TableBody>
                    )}

                </Table>
            </TableContainer>

        </Grid>

    )



}
